import { Validators } from '@angular/forms';
import { compose, prop, propObject, required } from '@rxweb/reactive-form-validators';
import { CustomValidators } from '../../../../extensions/custom-validators';
import { BaseRepresentativesDataModel } from './base.model';

export class RepresentativePoliticallyExposed {
    constructor() {}

    @compose({ validators: [ Validators.required, Validators.minLength(11), CustomValidators.isValidCPF() ]})
    socialNumber?: string;

    @prop()
    name?: string;

    @required()
    qualification?: string;

    @required()
    relationship?: number;
}

export class InvestorCompanyRepresentativesDataModel extends BaseRepresentativesDataModel {
    constructor() {
        super();
        this.politicallyExposed = new RepresentativePoliticallyExposed();
    }

    @required()
    role: string;

    @required()
    isPoliticallyExposed?: boolean;

    @propObject(RepresentativePoliticallyExposed)
    politicallyExposed?: RepresentativePoliticallyExposed;
}
